import {mapActions, mapGetters} from "vuex";

export default {
    components: {
        Header: () => import('@/components/header/index.vue'),
        leftBar: () => import('@/components/left-bar/index.vue'),
        TableOptions: () => import('@/components/table/options/index.vue'),
        Table: () => import('@/components/table/list/index.vue'),
    },
    data() {
        return {
            fields: [
                {
                    key: 'id',
                    label: 'id',
                },
                {
                    key: 'sms_order_id',
                    label: 'order_id',
                },
                {
                    key: 'number_phone',
                    label: 'Номер',
                },
                {
                    key: 'mailing_message',
                    label: 'Сообщение',
                },
                {
                    key: 'sms_balance',
                    label: 'Баланс',
                },
                {
                    key: 'sms_created_at',
                    label: 'Отправлено',
                },
                {
                    key: 'sms_updated_at',
                    label: 'Обновлено',
                },
                {
                    key: 'state',
                    label: 'Состояние',
                },
                {
                    key: 'mailing_status',
                    label: 'Обновлено',
                },
            ],
            items: [],
            stateList: [
                {
                    key: 'DELIVRD',
                    title: 'Сообщение доставлено получателю',
                },
                {
                    key: 'EXPIRED',
                    title: 'Истек срок сообщения',
                },
                {
                    key: 'DELETED',
                    title: 'Удалено оператором',
                },
                {
                    key: 'UNDELIV',
                    title: 'Не доставлено',
                },
                {
                    key: 'REJECTD',
                    title: 'Сообщение доставлено получателю',
                },
                {
                    key: 'UNKNOWN',
                    title: 'Сообщение доставлено получателю',
                },
            ],
        }

    },
    computed: {
        ...mapGetters({
            menuHide: 'config/menuHide',
            smsList: 'templates/smsList',
        })
    },
    watch: {
        smsList(e) {
            this.items = [];
            e.data.map(item => {
                const status = item.delivery_status ? item.delivery_status : '<span style="color: red;">Статус отсутствует</span>'
                let state = this.stateList.filter(itemState => itemState.key === status)
                state = state[0]
                this.items.push({
                    id: item.id,
                    sms_order_id: item.order_id,
                    number_phone: item.phone,
                    mailing_message: item.message,
                    sms_balance: item.balance,
                    sms_created_at: this.$moment(item.created_at).format('YYYY.MM.DD  HH:mm:ss'),
                    sms_updated_at: this.$moment(item.updated_at).format('YYYY.MM.DD  HH:mm:ss'),
                    mailing_status: status,
                    state: state ? state.title : '<span style="color: red;">Состояние отсутствует</span>',
                    stateInfo: state ? state.title : 'Состояние отсутствует',
                })
            })
        },
    },
    created() {
        this.getSmsList();
    },
    methods: {
        mailingReload(){
            this.getSmsList();
        },
        ...mapActions({
            getSmsList: 'templates/getSmsList'
        })
    }

}